// extracted by mini-css-extract-plugin
export default {"video-container":"UserSVideos_video-container__64HaL","video-content":"UserSVideos_video-content__Ourl4","video-item":"UserSVideos_video-item__F7+7l"};